"use client";

import { Instagram, Youtube, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
const capabilities = [{
  label: "Rock Wool Sandwich Panels",
  href: "/ProductsPage"
}, {
  label: "PU Sandwich Panels",
  href: "/ProductsPage"
}, {
  label: "Trapezoidal Sheets",
  href: "/ProductsPage"
}, {
  label: "PPGI Steel Coils",
  href: "/ProductsPage"
}, {
  label: "Galvanized Steel Coils",
  href: "/ProductsPage"
}, {
  label: "Fiberglass Facade Mesh",
  href: "/ProductsPage"
}, {
  label: "Decorative Interior Panels",
  href: "/ProductsPage"
}, {
  label: "Complete Steel Buildings",
  href: "/ProductsPage"
}];
const socials = [{
  name: "Instagram",
  icon: Instagram,
  href: "#"
}, {
  name: "YouTube",
  icon: Youtube,
  href: "#"
}, {
  name: "X",
  icon: Twitter,
  href: "#"
}];
export default function IndustrialFooter() {
  return <section data-section-id="4966" id="industrial-footer" className="relative bg-background text-foreground pt-[120px] pb-12 px-6 md:px-10 lg:px-16">
      {}
      <span aria-hidden="true" className="absolute top-4 left-4 w-4 h-4 border-l border-t border-border/60" />
      <span aria-hidden="true" className="absolute top-4 right-4 w-4 h-4 border-r border-t border-border/60" />
      <span aria-hidden="true" className="absolute bottom-4 left-4 w-4 h-4 border-l border-b border-border/60" />
      <span aria-hidden="true" className="absolute bottom-4 right-4 w-4 h-4 border-r border-b border-border/60" />

      <div className="max-w-7xl mx-auto">
        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          {}
          <div className="lg:col-span-5 space-y-6">
            <Link to="/" className="inline-block">
              <WvcLogo className="h-8 w-auto" />
            </Link>
            <p className="text-[14px] text-muted-foreground font-default max-w-sm leading-relaxed">
              Premium construction materials and distribution for European infrastructure.
            </p>

            {}
            <div className="pt-4 space-y-1.5 font-mono text-[11px] text-muted-foreground uppercase tracking-wider">
              <div className="flex items-center gap-2">
                <span className="text-muted-foreground/70">HQ</span>
                <span className="text-foreground/80">Bujanovac, Serbia</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-muted-foreground/70">REG</span>
                <span className="text-foreground/80">EU Distribution</span>
              </div>
            </div>

            {}
            <div className="flex items-center gap-5 pt-2">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Link data-index={i} key={social.name} to={social.href} aria-label={social.name} className="group text-foreground hover:text-primary transition-colors duration-200">
                    <Icon className="w-5 h-5" strokeWidth={1.5} aria-hidden="true" />
                  </Link>;
            })}
            </div>
          </div>

          {}
          <div className="lg:col-span-2">
            <h3 className="font-mono text-[12px] uppercase tracking-[0.15em] text-muted-foreground mb-6 font-default">
              Navigate
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/ProductsPage" className="text-foreground text-[15px] hover:text-primary transition-colors duration-200">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/AboutUsPage" className="text-foreground text-[15px] hover:text-primary transition-colors duration-200">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/ContactPage" className="text-foreground text-[15px] hover:text-primary transition-colors duration-200">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div className="lg:col-span-2">
            <h3 className="font-mono text-[12px] uppercase tracking-[0.15em] text-muted-foreground mb-6 font-default">
              Products
            </h3>
            <ul className="space-y-3">
              {capabilities.map((cap, i) => <li data-index={i} key={cap.label}>
                  <Link to={cap.href} className="text-foreground text-[15px] hover:text-primary transition-colors duration-200">
                    {cap.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="lg:col-span-3">
            <h3 className="font-mono text-[12px] uppercase tracking-[0.15em] text-muted-foreground mb-6 font-default">
              Contact
            </h3>
            <div className="space-y-4">
              <p className="text-[14px] text-muted-foreground leading-relaxed font-default">
                Industrial Zone, Bujanovac
                <br />
                Serbia
              </p>
              <div className="space-y-2 font-mono text-[13px]">
                <Link to="mailto:office@swisssolutionsgroup.com" className="block text-foreground hover:text-primary transition-colors duration-200">
                  office@swisssolutionsgroup.com
                </Link>
                <Link to="tel:+41765350002" className="block text-foreground hover:text-primary transition-colors duration-200">
                  +41 76 535 00 02
                </Link>
              </div>
              <div className="pt-2 font-mono text-[11px] text-muted-foreground uppercase tracking-wider">
                <span className="text-muted-foreground/70">Support </span>
                <span className="text-foreground/80">Mon-Fri 08-17</span>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="relative my-14">
          <div className="h-px bg-border w-full" />
          <span aria-hidden="true" className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center">
            <span className="block w-3 h-px bg-border" />
            <span className="block w-px h-3 bg-border absolute" />
          </span>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center font-mono text-[11px] uppercase tracking-[0.12em]">
          {}
          <div className="text-muted-foreground text-center md:text-left">
            © 2026 Swiss Solutions d.o.o. · All Rights Reserved
          </div>

          {}
          <div className="flex justify-center" />

          {}
          <div className="flex items-center gap-2 justify-center md:justify-end text-muted-foreground">
            <span className="w-1.5 h-1.5 rounded-lg bg-chart-2 animate-pulse" aria-hidden="true" style={{
            boxShadow: "0 0 8px var(--chart-2)"
          }} />
            <span>
              System Status: <span className="text-foreground/80">Operational</span> ·
              Coverage <span className="text-foreground/80">Europe</span>
            </span>
          </div>
        </div>
      </div>
    </section>;
}